// Fallback data in case lookup values aren't loaded from the database
export const fallbackCategories = [
  {
    id: "maintenance",
    category: "category",
    value: "maintenance",
    label: "Maintenance",
    color: "#F59E0B",
  },
  {
    id: "inspection",
    category: "category",
    value: "inspection",
    label: "Inspection",
    color: "#3B82F6",
  },
  {
    id: "repair",
    category: "category",
    value: "repair",
    label: "Repair",
    color: "#EF4444",
  },
  {
    id: "survey",
    category: "category",
    value: "survey",
    label: "Survey",
    color: "#10B981",
  },
  {
    id: "monitoring",
    category: "category",
    value: "monitoring",
    label: "Monitoring",
    color: "#8B5CF6",
  },
];

export const fallbackPriorities = [
  {
    id: "low",
    category: "priority",
    value: "low",
    label: "Low",
    color: "#6B7280",
  },
  {
    id: "medium",
    category: "priority",
    value: "medium",
    label: "Medium",
    color: "#F59E0B",
  },
  {
    id: "high",
    category: "priority",
    value: "high",
    label: "High",
    color: "#EF4444",
  },
  {
    id: "urgent",
    category: "priority",
    value: "urgent",
    label: "Urgent",
    color: "#DC2626",
  },
];

export const fallbackStatuses = [
  {
    id: "not_started",
    category: "task_status",
    value: "not_started",
    label: "Not Started",
    color: "#6B7280",
  },
  {
    id: "in_progress",
    category: "task_status",
    value: "in_progress",
    label: "In Progress",
    color: "#3B82F6",
  },
  {
    id: "completed",
    category: "task_status",
    value: "completed",
    label: "Completed",
    color: "#10B981",
  },
  {
    id: "on_hold",
    category: "task_status",
    value: "on_hold",
    label: "On Hold",
    color: "#F59E0B",
  },
  {
    id: "cancelled",
    category: "task_status",
    value: "cancelled",
    label: "Cancelled",
    color: "#EF4444",
  },
];
